<gsp-wizard
    [progressionSteps]="steps"
    [currentStep]="currentStep$ | async"
    [size]="ModalSize.Medium"
    id="import-file-fileviewer-wizard"
>
    <gsp-wizard-header
        [heading]="'TCS.Import.ImportFile'"
        (closed)="exit()"
        transclude-wizard-header
    ></gsp-wizard-header>
    <gsp-wizard-footer (goBack)="backward()" (goForward)="forward()" transclude-wizard-footer></gsp-wizard-footer>
</gsp-wizard>
